import Swiper from "swiper/bundle";

function initArticlesCarousel(root = document) {
    const swipers = root.querySelectorAll(".block-articles__swiper");

    swipers.forEach((el) => {
        if (el.swiper) {
            el.swiper.destroy(true, true);
        }

        if (!el.querySelector(".swiper-slide")) {
            return;
        }

        new Swiper(el, {
            slidesPerView: 2,
            slidesOffsetBefore: 16,
            spaceBetween: 16,
            watchOverflow: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 24
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 24
                }
            }
        });
    });
}

export { initArticlesCarousel };
